@if (state()=='validation') {<app-title-component [data]="{name : 'Validation des rapports de groupes'}"></app-title-component>}
@else if (state()=='reception') {<app-title-component [data]="{name : (groupe_name?'reception des rapports de suivi : '+groupe_name:'reception des rapports de suivi'), back : (groupe!=''), path :'suivi/reception'}"></app-title-component>}

<mat-card appearance="outlined" class="main-dashboard-card border-0 shadow-sm mt-5">
  
  <mat-card-header class="p-3 border-bottom bg-white d-flex justify-content-end">
    <div class="w-100 max-width-md">
      <app-search-bar-component (searchBarValue)="applyFilter($event)"></app-search-bar-component>
    </div>
  </mat-card-header>

  <mat-card-content class="position-relative p-3 bg-light custom-content-area">
    
    @if (loading()) {
      <div class="table-loading-overlay d-flex align-items-center justify-content-center">
        <mat-spinner diameter="48"></mat-spinner>
      </div>
    }

    <div class="row g-3">
      @for (item of data(); track item.id) {
        <div class="col-12 col-sm-6 col-md-4 col-xl-3">
          
          <mat-card matRipple [matRippleCentered]="true" class="grid-item-card h-100 border-0 shadow-sm" appearance="outlined"
            (click)="state() === 'reception' ? (groupe ? goToBureauGroupeDetails(item.id, groupe) : goToBureauGroupe(item.id, item.name)) : goToBureau(item.id)">
            
            <mat-card-header class="p-3 pb-2">
              <mat-card-title class="text-truncate fs-6 fw-bold text-dark m-0">
                @if (state() === 'reception' && !groupe) {
                  Groupe : {{ item.name }}
                } @else {
                  Bureau : {{ item.name }}
                }
              </mat-card-title>
              
              @if (state() === 'validation' || groupe) {
                <mat-card-subtitle class="text-muted small mt-1 mb-0">
                  Groupe : {{ item.groupe_name }}
                </mat-card-subtitle>
              }
            </mat-card-header>

            <mat-card-content class="px-3 pb-3 pt-0">
              <div class="meta-info-list mb-3">
                <div class="d-flex justify-content-between small text-muted py-1 border-bottom border-light">
                  <span>Stock documents</span>
                  <span class="fw-semibold text-dark">{{ item.stock_reste??0 }} / {{ item.stock_fourni??0 }}</span>
                </div>
                <div class="d-flex justify-content-between small text-muted py-1">
                  <span>Derniere transmission</span>
                  <span class="fw-medium text-dark">
                    {{ (state() === 'validation' ? item.transmit_le : item.valide_le) | date:'short' }}
                  </span>
                </div>
              </div>

              <div class="transmission-badge-wrapper text-center">
                <span class="badge-transmission d-block py-2 rounded-3 fw-semibold">
                  Transmis : {{ item.count ?? 0 }} / {{ item.total_count ?? 0 }}
                </span>
              </div>
            </mat-card-content>

          </mat-card>

        </div>
      } @empty {
        @if (!loading()) {
          <div class="col-12">
            <div class="alert alert-custom-info d-flex align-items-center p-3 rounded-3" role="alert">
              <mat-icon class="me-2 text-info-icon">info</mat-icon>
              <span class="fw-medium">Aucun rapport envoyé pour le moment.</span>
            </div>
          </div>
        }
      }
    </div>

  </mat-card-content>
</mat-card>

